import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import { CssBaseline } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

// 다국어
import { useTranslation } from 'react-i18next';

import MemberJoinArea from './MemberJoinArea';
import IntroductionArea from './IntroductionArea';
import TabMenu from './TabMenu';
import ProductDescriptionList from './ProductDescriptionList';
// ----------------------------------------------------------------------

const Licensefull = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'Column',
  margin: '0 auto',
  background:
    'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)), linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%)',
  textAlign: 'center',
  padding: theme.spacing(7, 0),
  color: '#fff',
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function ProductsPage() {
  // 다국어
  const { t } = useTranslation(['page']);
  const { t: tGuide } = useTranslation(['guide']);
  const { t: tImg } = useTranslation(['img']);
  const productDescriptionList = tGuide('productDescriptionList', { returnObjects: true });
  return (
    <>
      <CssBaseline />
      <Helmet>
        <title> 제품소개 | RainDrop </title>
      </Helmet>
      <Box
        sx={{
          width: '100%',
          background: '#1a9ef8',
          flex: 1,
        }}
      >
        <IntroductionArea
          backgroundImgSrc={tImg('download_img_1')}
          introductionText={tGuide('introduction')}
          introductionSubText={tGuide('introductionSub')}
        />
      </Box>
      <TabMenu />
      <Licensefull>
        <h2>{tGuide('centerIntroduction.main')}</h2>
        <h4 style={{ fontWeight: '300', marginTop: '10px' }}>{tGuide('centerIntroduction.sub')}</h4>
      </Licensefull>
      <ProductDescriptionList list={productDescriptionList} />r
      <MemberJoinArea
        notMemberText={t('아직 회원이 아니신가요?')}
        descriptionText={t('회원가입도 간편하게 지금 바로 등록하세요.')}
        simpleJoinText={t('간편 회원가입')}
      />
    </>
  );
}
